import { Datepicker } from '@getsynapse/design-system';
import { intakeQuestionWrapper } from 'utils/customTypes';
import get from 'lodash/get';
import { useMemo } from 'react';
import { formatDate } from './dateHelpers';
import { useFlags } from 'launchdarkly-react-client-sdk';
const IntakeDateQuestion = ({
  question,
  handler,
  disabled,
}: intakeQuestionWrapper) => {
  const canSelectRange = get(question, 'data.range');
  const { timezoneRequestDates } = useFlags();

  const date = useMemo(() => {
    if (canSelectRange) {
      return {
        startDate: question.data.value?.startDate
          ? new Date(question.data.value.startDate)
          : undefined,
        endDate: question.data.value?.endDate
          ? new Date(question.data.value.endDate)
          : undefined,
      };
    } else {
      return {
        startDate: question.data.value
          ? new Date(question.data.value)
          : undefined,
      };
    }
  }, [canSelectRange, question.data.value]);

  const changeDate = (event: any) => {
    const formattedStartDate = timezoneRequestDates
      ? (formatDate(event.startDate) as string)
      : event.startDate;
    const formattedEndDate = timezoneRequestDates
      ? (formatDate(event.endDate) as string)
      : event.endDate;
    if (canSelectRange) {
      handler(
        question,
        { startDate: formattedStartDate, endDate: formattedEndDate },
        'data.value'
      );
    } else {
      handler(question, formattedStartDate, 'data.value');
    }
  };

  return (
    <Datepicker
      className='w-full'
      canSelectRange={canSelectRange}
      onPickDate={changeDate}
      startDate={date.startDate} // Date object or undefined
      endDate={date.endDate} // Date object or undefined
      startPlaceHolder={get(question, 'data.placeholder')}
      endPlaceHolder={get(question, 'data.placeholder2')}
      disabled={disabled}
      startDateLabelProps={{
        required: question.data.isRequired,
      }}
      endDateLabelProps={{
        required: canSelectRange && question.data.isRequired,
      }}
    />
  );
};

export default IntakeDateQuestion;
